import feature7s from "../clients/7s/feature.json";
import featureOtg from "../clients/otg/feature.json";
import featureBuko from "../clients/buko/feature.json";
import featurePickleCityPlus from "../clients/picklecityplus/feature.json";
import featureStMichaelExorcism from "../clients/stmichaelexorcism/feature.json";
import featureBoholSocialClub from "../clients/boholsocialclub/feature.json";
import { appConfig } from "./app.config";

export const appFeatureRecord = {
  ["buko"]: featureBuko,
  ["7s"]: feature7s,
  ["otg"]: featureOtg,
  ["picklecityplus"]: featurePickleCityPlus,
  ["stmichaelexorcism"]: featureStMichaelExorcism,
  ["boholsocialclub"]: featureBoholSocialClub,
};
export const appFeature =
  appFeatureRecord[appConfig.client as keyof typeof appFeatureRecord];
